import Vue from "vue";

let defaultRoleList = ["client", "admin"];
let config = Vue.observable({
  gtagId: "",
  siteLogo: "logo.png",
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  clientSideUrl: process.env.VUE_APP_CLIENT_SIDE_URL || "https://teacherskaya.ru",
  apiUrl: (window as any).VUE_APP_API_URL || process.env.VUE_APP_API_URL || "https://teacherskaya.ru/graphql",
  backendUrl: (window as any).VUE_APP_BACKEND_URL || process.env.VUE_APP_BACKEND_URL || "https://teacherskaya.ru/api",
  s3Url: (window as any).VUE_APP_S3_URL || process.env.VUE_APP_S3_URL || "https://teacherskaya.ru/files",
  thumbnailUrl: (window as any).VUE_APP_THUMBNAIL_URL || process.env.VUE_APP_THUMBNAIL_URL || "https://teacherskaya.ru/image-thumbnails",
  videoThumbnailUrl:
    (window as any).VUE_APP_VIDEOTHUMBNAIL_URL || process.env.VUE_APP_VIDEOTHUMBNAIL_URL || "https://teacherskaya.ru/video-thumbnails",
  currencyList: ["EUR", "USD"],
  testPaymentSystem: {
    type: "test",
  },
  get userRoleList() {
    return [...defaultRoleList];
  },
  set userRoleList(value) {
    defaultRoleList = value;
  },
  userRegistrationRole: "client",
  questionaryHiddenField: [] as string[],
  fileTypes: {
    image: [
      "jpg",
      "jpeg",
      "jpe",
      "heif",
      "heic",
      "png",
      "webp",
      "jxr",
      "jif",
      "jfif",
      "jfi",
      "jp2",
      "j2k",
      "jpf",
      "jpx",
      "jpm",
    ],
    video: ["webm", "mkv", "mov", "qt", "wmv", "mp4", "m4v", "mpg", "mpeg", "mpv", "avi"],
    audio: ["mp3", "aac", "ogg", "m4a"],
    document: ["pdf"],
  },
  // if true then allow to edit and view phone sign/login process
  featurePhoneSignUp: false,
  siteName: "Admin Teacherskaya",
  disabledPages: [] as string[],
  featureSubscriptions: true,
  // if true, will show "Manage profile" link on profile page which redirects and logins into user account on client
  featureLoginAsUser: true,
  featureTalentAgents: false,
  featureCustomDomain: false,
  // if true, admin can export xml list all of users
  featureUserListExport: true,
  // if true, show the statistics in PageDashboard
  featureDashboardStatistics: true,
  // if true, user can set custom dark mode palette
  featureDarkMode: true,
});

export function setConfig(override: Partial<typeof config>) {
  // tslint:disable-next-line:forin
  for (const key in override) {
    Vue.set(config, key, override[key as keyof typeof override]);
  }
}

export default config;
